// extracted by mini-css-extract-plugin
export default {"root":"ImageModal_root__HFiJy"};